import { useAtomValue } from "jotai";
import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { useFlag } from "../../server/optimizely";
import { CeDropdown } from "../generic/components/form-fields/ce-dropdown";
import { multiformatAtom } from "../multiformat/store/multiformat-atom";
import {
  type ContentTypeOption,
  type CreateContentRequest,
  type Multiformat,
} from "../multiformat/store/types";

export function sortTypes(
  multiformat: Multiformat,
  incudePrototypes: boolean,
): ContentTypeOption[] {
  const sorting = [
    "Communication",
    "Video",
    "Landscape Logo",
    "Square Logo",
    "TV Display",
    "Certificate",
    "Video Call Background",
    "Poster",
    "FAQ",
    "Manager One-Pager",
    "Horizontal Banner",
    "Guide",
  ];

  return multiformat.content_types
    .filter((contentType) => incudePrototypes || !contentType.prototype)
    .sort((a, b) => {
      const indexA = sorting.indexOf(a.name);
      const indexB = sorting.indexOf(b.name);

      const rankA = indexA === -1 ? Infinity : indexA;
      const rankB = indexB === -1 ? Infinity : indexB;

      if (rankA === rankB) {
        return a.name.localeCompare(b.name);
      }

      return rankA - rankB;
    })
    .map((c) => ({
      label: c.name,
      value: c.name,
    }));
}

export const ContentTypeSelect: FC = () => {
  const [mfai_prototypes] = useFlag("mfai_prototypes");
  const loader = useAtomValue(multiformatAtom);
  const sortedTypes =
    loader.loading || !loader.data ? undefined : sortTypes(loader.data, mfai_prototypes);

  const { t } = useTranslation();
  return (
    <CeDropdown<CreateContentRequest>
      label={t("Content Type")}
      name="format"
      loading={!sortedTypes}
      options={sortedTypes ?? []}
    />
  );
};

export const ContentTypeSelectNew: FC = () => {
  const [mfai_prototypes] = useFlag("mfai_prototypes");
  const loader = useAtomValue(multiformatAtom);
  const sortedTypes =
    loader.loading || !loader.data ? undefined : sortTypes(loader.data, mfai_prototypes);

  const { t } = useTranslation();
  return (
    <CeDropdown<CreateContentRequest>
      label={t("Format")}
      name="format"
      loading={!sortedTypes}
      options={sortedTypes ?? []}
      InputProps={{
        sx: {
          backgroundColor: "white",
          borderRadius: 2,
        },
      }}
    />
  );
};
